import { AfterContentInit, Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BUSINESS_CONST } from 'src/app/shared/constants/business.constants';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';
import { FormatNumberService } from 'src/app/shared/utils/format-number.service';

import { OpEnum } from '../../../shared/enums/op.enum';
import { CityModel, OfficeModel } from '../../../shared/models/abre-cuentas.model';
import { OccupationModel } from '../../../shared/models/occupation.model';
import { AbreCuentasService } from '../../../shared/services/abre-cuentas/abre-cuentas.service';
import { CaptureService } from '../../../shared/services/capture/capture.service';
import { CopyService } from '../../../shared/services/copies/copy.service';
import { HeaderService } from '../../../shared/services/header/header.service';
import { StringHelperService } from '../../../shared/services/helpers/string-helper.service';
import { NavigationService } from '../../../shared/services/navigation/navigation-onboarding.service';
import { RequestService } from 'src/app/shared/services/request/request-onboarding.service';

@Component({
  selector: 'app-form-employee',
  templateUrl: './form-employee.component.html',
  styleUrls: ['./form-employee.component.scss'],
})
export class FormEmployeeComponent implements OnInit, AfterContentInit {

  formGroup: FormGroup;
  options: [any];
  selectedCity: CityModel;
  reactiveErrorTelephone: string;
  reactiveErrorCompany: string;
  reactiveErrorAddress: string;
  selectedOccupation: OccupationModel;
  officeInfo: OfficeModel;
  productType: string;
  has_second_headline: any;
  district_option: any;
  selected_district: any;
  city_option: any;

  constructor(
    public copyService: CopyService,
    private headerService: HeaderService,
    private captureService: CaptureService,
    private navigationService: NavigationService,
    private abreCuentasService: AbreCuentasService,
    private parametersService: ParametersService,
    private stringHelperService: StringHelperService,
    private formatNumber: FormatNumberService,
    private requestService: RequestService) {
    this.district_option = this.abreCuentasService.getDistricts();
    this.headerService.show(true, true, true);
  }

  ngOnInit() {
    this.has_second_headline = this.abreCuentasService.getSecondHeadline();
    this.selectedOccupation = (!this.has_second_headline || !this.has_second_headline.has_second_headline)
      ? this.abreCuentasService.getOccupationSelected()
      : this.abreCuentasService.getOccupationSelectedSecondHeadline();
    // this.options = this.parametersService.getSetting(OpEnum.CITY_LIST);
    const productSelected = this.abreCuentasService.getproductSelected();
    this.productType = productSelected ? productSelected.product_type : '';
    this.officeInfo = (!this.has_second_headline || !this.has_second_headline.has_second_headline) ?
      this.abreCuentasService.getOfficeInfo(this.selectedOccupation.id + '') :
      this.abreCuentasService.getOfficeSecondHeadlineInfo(this.selectedOccupation.id + '');
    this.selectedCity = this.officeInfo.address.city;
    this.selected_district = this.selectedCity.district_id;
    if (this.productType === 'payroll') {
      this.officeInfo.company_nameInput = this.abreCuentasService.getAgreementSelected().agreement_name;
    }
  }

  /**
   * Summary Call after angular has fully started the component view, initialization of the form
   */
  ngAfterContentInit() {
    const companyName = (!this.has_second_headline || !this.has_second_headline.has_second_headline)
      ? this.officeInfo.company_name
      : this.officeInfo.company_nameInput;
    this.formGroup = new FormGroup({
      'input-value-company': new FormControl(companyName, Validators.required),
      'input-value-address': new FormControl(this.officeInfo.address.addressInput,
        [Validators.required, Validators.minLength(4), Validators.maxLength(40), Validators.pattern(new RegExp(/^[Ññ\w-#/., ]+$/))]),
      'input-value-addressDetail': new FormControl(this.officeInfo.address.detail, [Validators.maxLength(40)]),
      'input-value-telephone': new FormControl(this.officeInfo.office_number, [Validators.pattern(/^\d{7,10}$/),
        Validators.maxLength(10)]),
    });
    if (this.productType === 'payroll') {
      return;
    }
    const controlCompany = this.formGroup.controls['input-value-company'] as FormControl;
    const regexp1 = new RegExp(/^(?!.*[ ]{2}).+$/);
    controlCompany.setValidators([Validators.required, Validators.minLength(2), Validators.maxLength(80), Validators.pattern(regexp1)]);
  }

  /**
   * Summary normalize address
   */
  validateCompany(): string {
    const controlCompany = this.formGroup.controls['input-value-company'] as FormControl;
    return this.stringHelperService.normalizeCompany(controlCompany.value).normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  /**
   * Summary normalize address
   */
  validateAddress(): string {
    const controladdress = this.formGroup.controls['input-value-address'] as FormControl;
    const controladdressdetail = this.formGroup.controls['input-value-addressDetail'] as FormControl;
    controladdress.setValue(controladdress.value.replace(/[^A-Za-z0-9\s#\-.]/g, '').replace(/\s{2,}/g, ' '));
    return this.stringHelperService.normalizeAddress(controladdress.value, controladdressdetail.value);
  }

  getNumberFormat(value: string) {
    // const formatNumber = new FormatNumberService();

    return this.formatNumber.formatNumberPhone(value);
  }

  /**
   * Se ejecuta cada vez que se inicia la edición de número de teléfono
   *
   * *It executes each time begins the phone editing*
   */
  inputPhone($event: any) {
    const value = $event.target.value;
    const phone = this.getNumberFormat(value);
    $event.target.value = phone.clearValue;
  }

  /**
   * Se ejecuta cada vez que termina la edición de número de teléfono
   *
   * *It executes each time finish the phone editing*
   */
  outPhone($event: any) {
    const value = $event.target.value;
    const phone = this.getNumberFormat(value);
    $event.target.value = phone.format;
  }

  /**
   * Summary Telephone entry change event, error validation
   */
  reactiveInputTelephone() {
    const controladdressTelephone = this.formGroup.controls['input-value-telephone'] as FormControl;
    controladdressTelephone.setValue(controladdressTelephone.value.slice(0, 10));
    controladdressTelephone.setValue(controladdressTelephone.value.replace(new RegExp(/[^\d]/), ''));
  }

  /**
   * Summary Address entry change event, error validation
   */
  reactiveInputChangeAddress() {
    const controladdress = this.formGroup.controls['input-value-address'] as FormControl;
    controladdress.setValue(controladdress.value.replace(/[^A-Za-z0-9\s#\-.]/g, '').replace(/\s{2,}/g, ' '));
    this.reactiveErrorAddress = this.setValueByValidateBoolean(
      controladdress.valid,
      '',
      'Por favor ingresa una dirección válida. Ej: Carrera 00# 00a - 00.');
  }

  reactiveInputCompany() {
    const controladdressCompany = this.formGroup.controls['input-value-company'] as FormControl;
    controladdressCompany.setValue(controladdressCompany.value.replace(/[^A-Za-z0-9&\s]/g, '').replace(/\s{2,}/g, ' '));
    this.reactiveErrorCompany = this.setValueByValidateBoolean(controladdressCompany.valid, '', 'La empresa es requerida.');
  }

  setValueByValidateBoolean(validValue: boolean, caseTrue: string, caseFalse: string) {
    return (validValue) ? caseTrue : caseFalse;
  }

  /**
   * Summary Event for select a option for list selected, and set value in Input
   * @param option
   */
  selectOption(option: any) {
    if (option.value) {
      this.selectedCity = option.value;
      return;
    }
    this.selectedCity = {
      country_code: '',
      province_code: 0,
      city_code: '',
      description: '',
    };

  }

  /**
   * Summary next event validation
   */
  next() {
    const body = {
      occupation_id: this.abreCuentasService.getOccupationSelected().id,
      company_name: this.validateCompany(),
      company_nameInput: this.formGroup.controls['input-value-company'].value,
      address: {
        city: this.selectedCity,
        address: this.validateAddress(),
        detail: this.formGroup.controls['input-value-addressDetail'].value,
        addressInput: this.formGroup.controls['input-value-address'].value,
      },
      office_number: this.formGroup.controls['input-value-telephone'].value,
    };
    this.officeInfo = body;
    if (typeof this.has_second_headline === 'undefined' || !this.has_second_headline.has_second_headline) {
      this.abreCuentasService.setOfficeInfo(this.abreCuentasService.getOccupationSelected().id + '', this.officeInfo);
      this.abreCuentasService.getContactInfo().employment_number = this.formGroup.controls['input-value-telephone'].value !== '' ?
        this.formGroup.controls['input-value-telephone'].value : null;
    } else {
      this.abreCuentasService.setOfficeSecondHeadlineInfo(this.abreCuentasService.getOccupationSelected().id + '', this.officeInfo);
      this.abreCuentasService.getContactInfoSecondHeadline().employment_number =
        this.formGroup.controls['input-value-telephone'].value !== '' ?
          this.formGroup.controls['input-value-telephone'].value : null;
    }
    if (this.abreCuentasService.getproductSelected().product_type === BUSINESS_CONST.PRODUCT_TYPE_LIVING) {
      this.navigationService.nextStep('200');
      return;
    }
    this.captureService.sendProspectOfficeAddress(body).then(
      (res: any) => {
        if (!res) {
          return;
        }
        if (+res.status !== 200) {
          this.navigationService.navigateToGeneralInformation('500');
        } else {
          this.navigationService.nextStep('200');
        }
      },
    ).catch(() => this.navigationService.navigateToGeneralInformation('500'));
  }

  async getCitysEmployee(provence_id: string) {
    await this.requestService.cityBranches(provence_id).then(resp => {
      this.city_option = resp.body;
      this.options = this.city_option.map(data => {
        const codeDaneEmployee = data.code_dane;
        const codeDanelength = codeDaneEmployee.length - 3;
        return {
          city_code: codeDaneEmployee.substring(codeDanelength),
          province_code: +codeDaneEmployee.substring(0, codeDanelength),
          description: data.city,
          district_id: data.district.district_id,
        };
      },
        );
    });
  }

  selectOptionProvidence(event) {
    const valueProvidence: string = event.value;
    if (valueProvidence && valueProvidence.trim() !== '') {
      this.selected_district = valueProvidence;
      this.getCitysEmployee(valueProvidence);
    } else {
      this.city_option = undefined;
      this.selectedCity = { city_code: '', country_code: '', province_code: 0, description: '' };
      this.selected_district = undefined;
    }
  }

}
